var myCountries =
    ['Colombia', 'Chile', 'Ecuador', 'Honduras', 'Venezuela']

var timeZones = {

    '': {
        'countries': [
        ''
        ]
    },
    'Colombia':{
      'time_zones':[{name:'Bogotá', code: 'America/Bogota'}],
      'indicative':57
    },
    'Chile':{
      'time_zones':
      [{name:'Santiago', code:'America/Santiago'},
      {name:'Punta Arenas',code:'America/Punta_Arenas'},
      {name:'Isla de Pascua',code:'Pacific/Easter'}],
      'indicative':56
    },
    'Ecuador':{
      'time_zones':[{name:'Quito', code: 'America/Bogota'}],
      'indicative':593
    },
    'Honduras':{
      'time_zones':[{name:'Quito', code: 'America/Tegucigalpa'}],
      'indicative':504
    },
    'Venezuela':{
      'time_zones':[{name:'Caracas', code: 'America/Caracas'}],
      'indicative':58
    },
}



export default {
    myCountries,
    timeZones,
  }



// WEBPACK FOOTER //
// ./src/vue/additionalData/countries.js